<template>
<transition name="opacity" >
  <div class="video-popup" 
    v-show="isOpen">

      <Button 
        @click.native="showHidePopup" 
        :outlined="false" 
        :hasIcon="true" 
        type="white" 
        class="play-btn text-uppercase font--600">
          <span>Lukk</span>
          <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path fill="#143D54" d="M14.790374 12.4999258l9.7344976-9.73479401c.6335045-.633208.6335045-1.6570178 0-2.2902258-.633208-.63320799-1.6570178-.63320799-2.2902258 0l-9.7347941 9.73479411L2.76535421.474906c-.63350456-.633208-1.6570178-.633208-2.29022579 0-.63350456.63320799-.63350456 1.65701779 0 2.29022579L10.209626 12.4999258.47512842 22.2347199c-.63350456.633208-.63350456 1.6570178 0 2.2902258.31556594.3158625.73048772.4745353 1.14511293.4745353.41462514 0 .82925036-.1586728 1.14511286-.4745353l9.73449749-9.7347941 9.7347941 9.7347941c.3158625.3158625.7304877.4745353 1.1451129.4745353s.8292503-.1586728 1.1451129-.4745353c.6335045-.633208.6335045-1.6570178 0-2.2902258l-9.7344976-9.7347941z"/></svg>
      </Button>

      <div class="inner-pop">
          <div v-if="(videoID && isTriggered) || ytId" ref="videoPlayer" class="video-player" :class="uniqVideoClass">
            <youtube v-if="ytId" :player-vars="playerYtVars" :video-id="ytId" ref="youtube" @playing="playing" />
            <vueVimeoPlayer v-else ref="player" :video-id="videoID" @ready="onReadyVimeo" :options="vimeoPlayerOpt" :autoplay="true" />
          </div>
          <Preloader class="loader" />
      </div>

      <div class="overlay-popup" 
        @click="showHidePopup"
        @touchmove="prventScroll" 
      ></div>
  </div>
</transition>
</template>


<script>
import Preloader from '@/components/elements/Preloader';
import Button from '@/components/elements/Button'
import { vimeoID } from '@/helpers'
import shortid from 'shortid'
import { vueVimeoPlayer } from 'vue-vimeo-player'
// https://www.npmjs.com/package/vue-youtube

export default {
  name: 'video-popup',
  props:{
    isOpen: {
      default: false,
      type: Boolean
    },
    videoUrl:{
      default: '',
      type: String
    }
  },
  data(){
    return {
      playerIsReady: false,
      isTriggered: false,
      playerIsPlaying: false,
      apiInit: false,
      YTPlayer: null,
      ytId: false,
      playerYtVars: {
        //autoplay: 1
      },
      vimeoPlayerOpt: {
        loop: false,
        autoplay: 1,
        background: 0,
        muted: false
      },
    }
  },
  
  components:{
    Preloader,
    Button,
    vueVimeoPlayer
  },
  mounted(){
    var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    this.ytId =  this.videoUrl.includes('youtube') ? this.videoUrl.match(regExp) : false
    if(this.ytId && this.ytId.length && this.ytId[2]){
      this.ytId = this.ytId[2]
    }else{
      this.ytId = false
    }
  },
  watch: {
    playerIsPlaying(val){
      this.$emit('play', val)
    },
    playerIsReady(val){
      this.$emit('ready', val)
    },
    isOpen(val){
      if(val){
        if(this.ytId){
          this.playYtVideo()
        }

        if(!this.isTriggered){
          this.isTriggered = true;
        }
        document.getElementsByTagName('html')[0].classList.add('popup-open')
        if(!this.playerIsPlaying && this.isTriggered && this.$refs.player){
          this.$refs.player.play()
          this.playerIsPlaying = true
        }
      }else{
        if(this.ytId){
          this.pauseYtVideo()
        }
        if(this.playerIsPlaying && this.isTriggered && this.$refs.player){
          this.$refs.player.pause()
          this.playerIsPlaying = false
        }
        document.getElementsByTagName('html')[0].classList.remove('popup-open')
      }
    }
  },
  computed:{
    ytPlayer() {
      return this.$refs && this.$refs.youtube ? this.$refs.youtube.player : false
    },
    uniqVideoClass(){
      return 'video-'+shortid.generate()
    },
    videoID(){
      return vimeoID(this.videoUrl)
    }
  },
  methods:{
    playYtVideo() {
      if(this.ytPlayer) this.ytPlayer.playVideo()
    },
    pauseYtVideo() {
      if(this.ytPlayer) this.ytPlayer.pauseVideo()
    },
    playing(){
      //console.log('playginf')
    },
    onReadyVimeo(){
      this.playerIsPlaying = true
      this.playerIsReady = true
    },
    showHidePopup(){
      this.$emit('close')
    },
    prventScroll(e){
      e.preventDefault();
      e.stopPropagation();

    },
  }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.video-popup{
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .overlay-popup{
      cursor: pointer;
      background-color: $dark;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
  }
  .inner-pop{
      text-align: left;
      position: relative;
      z-index: 20;
      max-width: 1200px;
      width: 90%;
      height: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @include mquery($tablet){
          width: 95%;
      }
      @include mquery($phone){
      }
      .loader{
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          position: absolute;
          z-index: 10;
          margin-top: 0 !important;
      }

      
  }
  .play-btn{
      cursor: pointer;
      position: absolute;
      top: 50px;
      right: 50px;
      z-index: 95;
      @include mquery($tablet){
        top: 30px;
        right: 30px;
      }
      @include mquery($phone){
        top: 15px;
        right: 15px;
      }
  }
  .video-player{
      z-index: 20;
      max-height: 0;
      position: relative;
      padding-bottom: 56.25%;
      iframe{
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
      }
  }
}
</style>